import React, { useState, useEffect } from 'react'
import { Autocomplete, Box, Button, Divider, TextField } from '@mui/material'
import { RootState } from '../../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from '../../CaseWorklist/Pathologist/inboxStyles'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import CircularProgress from '@mui/material/CircularProgress'
import {
  getPathologistsList,
  consultComplete,
  saveDraftReportData,
  setCaseData,
  fetchInboxData,
  getDraftReportData,
} from '../../../actions'

export default function ConsultComplete({
  open,
  onClose,
  handleConsultCompleteSuccess,
  savedConsults,
  setSavedConsults,
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { user } = useSelector((state: RootState) => state.userLogin)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [openErrorSnackBar, setOpenErrorSnackBar] = useState(false)
  const getUsers = useSelector((state: RootState) => state.addPathologistsList)
  const data = useSelector((state: RootState) => state.getCaseData)
  const { re_consultComplete_success, re_consultComplete_error } = useSelector(
    (state: RootState) => state.updateConsultCompleteResponse,
  )
  const { re_pathologistsList_success, re_pathologistsList_error } = useSelector(
    (state: RootState) => state.getPathologistsListResponse,
  )
  const savedDraftReportData = useSelector((state: RootState) => state.setDraftReportData)
  let activePathologists = []
  const pathologists = getUsers?.data
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [loading, setLoading] = useState(false)
  const [isPathologistsListLoading, setTranferListLoading] = useState(true)
  const [savedConsultsOnCancel, setSavedConsultsOnCancel] = useState([] as any)

  const getClassNames = () => (disableSubmit ? `${classes.disableBtn} ` : `${classes.btn} ${classes.buttonMargin}`)

  useEffect(() => {
    const savedConsultNames = [] as any
    if (savedDraftReportData && savedDraftReportData.consultedPats && savedDraftReportData.consultedPats.length > 0) {
      savedDraftReportData.consultedPats.map((user) => {
        savedConsultNames.push(user.name)
      })
      setSavedConsults(savedConsultNames)
      setSavedConsultsOnCancel(savedConsultNames)
    }
  }, [savedDraftReportData])

  if (pathologists) {
    const filterUserResults = pathologists.filter((value) => {
      if (value.user_roles) {
        return value.user_roles == 'NL_Pathologist' && value.user_status === true
      }
    })
    const filterResultsByloginUser = filterUserResults.filter((value) => {
      return value.user_id !== user
    })
    activePathologists = filterResultsByloginUser.map((currentUser) => {
      if (currentUser.id !== user) {
        return `${currentUser.first_name} ${currentUser.last_name}`
      }
    })
  }

  useEffect(() => {
    if (open) {
      dispatch(
        getPathologistsList({
          id: user,
          caseId: data.caseId,
        }),
      )
    }
  }, [open])

  useEffect(() => {
    setTimeout(() => setTranferListLoading(false), 4000)
  }, [isPathologistsListLoading])

  const handleConsultedDocsChange = (val) => {
    setDisableSubmit(false)
    setSavedConsults(val)
  }

  const createConsultEmailObject = (val) => {
    const consultedPathologists = [] as any
    if (val.length) {
      val.map((item) => {
        const lastName = item.split(' ')
        const lastNameValue = lastName.length > 2 ? lastName[0] + ' ' + lastName[1] : lastName[0]
        const filterUserResults = pathologists.filter((value) => {
          return value.first_name == lastNameValue
        })
        const pathologistUsers = { email: filterUserResults[0].email_id, name: item }
        consultedPathologists.push(pathologistUsers)
      })
    }
    return consultedPathologists
  }

  const handleConsultComplete = async () => {
    const savedConsultsObject = createConsultEmailObject(savedConsults)
    setLoading(true)
    setOpenErrorSnackBar(false)
    setOpenSuccessSnackBar(false)
    await dispatch(
      saveDraftReportData({
        trfBarcode: savedDraftReportData.trfBarcode,
        calloutDecision: savedDraftReportData.calloutDecision,
        consultedPats: savedConsultsObject,
        reportBuilder: savedDraftReportData.reportBuilder,
      }),
    )
    await dispatch(getDraftReportData({ trfBarcode: savedDraftReportData.trfBarcode }))
    if (savedConsults.length) {
      await dispatch(
        consultComplete({
          userId: user,
          caseId: data.caseId,
        }),
      )
      setTimeout(updateDataTable, 1500)
    } else {
      onClose(true)
      setOpenErrorSnackBar(true)
    }
  }

  const updateWorklowStage = (type) => {
    switch (type) {
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT':
        return 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS'
      case 'CORRECT_ASSIGNED_CONSULT':
        return 'CORRECT_ASSIGNED_INPROGRESS'
    }
  }

  const updateDataTable = async () => {
    if (data) {
      await dispatch(
        setCaseData({
          pathologistId: data.pathologistId,
          pathologist: data.pathologist,
          caseNumber: data.caseNumber,
          procedureCodeId: data.procedureCodeId,
          workflowId: updateWorklowStage(data.workflowId),
          patientName: data.patientName,
          caseId: data.caseId,
          nlOrderId: data.nlOrderId,
          userCaseWorkflowId: data.userCaseWorkflowId,
          slideStatusId: data.slideStatusId,
          mcFlag: data.mcFlag,
          statFlag: data.statFlag,
        }),
      )
    }
    await dispatch(
      fetchInboxData({
        id: `${user}`,
        filterField: 'created_datetime',
        filterValue: null,
        caseView: 'assigned',
        startDate: null,
        endDate: null,
        sortOrder: 'asc',
        sortField: 'case_number',
        pageIndex: 0,
        pageSize: 10,
      }),
    )
    handleConsultCompleteSuccess()
    setOpenSuccessSnackBar(true)
    setLoading(false)
  }

  function handleCloseDialog() {
    setSavedConsults(savedConsultsOnCancel)
    setTranferListLoading(true)
  }

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      {openSuccessSnackBar && re_consultComplete_success && (
        <SuccessSnackBar message="Successfully completed consultation" />
      )}
      {openErrorSnackBar && re_consultComplete_error && <ErrorSnackBar message="Case consultation failed" />}
      <Dialog fullWidth maxWidth="sm" id="hello" open={open} onClose={onClose} style={{ minHeight: '750px' }}>
        <DialogTitle className={classes.dialogTitle}>Consult Completion</DialogTitle>
        <Divider />
        {isPathologistsListLoading === true && (
          <DialogContent style={{ minHeight: '215px' }}>
            <CircularProgress style={{ marginTop: '50px', marginLeft: '250px' }} />
          </DialogContent>
        )}
        {isPathologistsListLoading === false && re_pathologistsList_error && (
          <DialogContent style={{ minHeight: '165px' }}>
            <WarningAmberOutlinedIcon color="warning" />
            <div className={classes.warningIcon}>Unable to retrieve pathologists list.</div>
          </DialogContent>
        )}
        {re_pathologistsList_success && isPathologistsListLoading === false && (
          <>
            <DialogContent classes={{ root: classes.dialogContentBox }} style={{ minHeight: '165px' }}>
              <DialogContentText className={classes.dialogContent}>
                Select the list of pathologists that you have consulted.
              </DialogContentText>
              <Autocomplete
                multiple
                value={savedConsults}
                disableClearable
                id="combo-box-demo"
                options={activePathologists}
                onChange={(e, val) => handleConsultedDocsChange(val)}
                sx={{ width: 300, marginTop: '15px' }}
                renderInput={(params) => <TextField {...params} label={`Consult To`} />}
              />
              {loading && (
                <CircularProgress className={classes.loadingIndicator} style={{ width: '30px', height: '30px' }} />
              )}
            </DialogContent>
          </>
        )}

        {re_pathologistsList_success && isPathologistsListLoading === false && (
          <DialogActions className={classes.buttonActions}>
            <Button className={getClassNames()} onClick={handleConsultComplete} endIcon={<CheckIcon />}>
              Submit
            </Button>
            <Button
              onClick={function (event) {
                handleCloseDialog()
                onClose()
              }}
              variant="outlined"
              className={classes.buttonMargin}
              endIcon={<ClearIcon />}
            >
              Cancel
            </Button>
          </DialogActions>
        )}
        {re_pathologistsList_error && isPathologistsListLoading === false && (
          <DialogActions className={classes.buttonActions}>
            <Button
              onClick={function (event) {
                handleCloseDialog()
                onClose()
              }}
              variant="outlined"
              className={classes.buttonMargin}
              endIcon={<ClearIcon />}
            >
              Close
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </Box>
  )
}
